import { render, staticRenderFns } from "./personalConfigList.vue?vue&type=template&id=0dd95e45"
import script from "./personalConfigList.vue?vue&type=script&lang=js"
export * from "./personalConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports